import ping from "./ping";
import bsb from "./bsb";
import documents from "./documents";
import onboarding from "./onboarding";
import superfund from "./superfund";

export { onboarding, ping, bsb, documents, superfund };
export default { onboarding, ping, bsb, documents, superfund };
